
import { Component, Vue } from "vue-property-decorator";
import Sidebar from "@/components/navigations/sidebar.vue";
import Cta from "@/components/buttons/Button.vue";
import Tag from "@/components/tags/Tag.vue";
import Tabs from "@/components/tabs/Tab.vue";
import CardMapStations from "@/components/card/cardMapStations.vue";
import { vehicules } from "@/store";
import { Vehicule } from "@/models";
import dayjs from "dayjs";

@Component({
  components: {
    Sidebar,
    Cta,
    Tag,
    Tabs,
    CardMapStations,
  },
})
export default class OpeVehicules extends Vue {
  tabSelected = "vehicules";
  tabs = [
    { key: "vehicules", label: "Véhicules" },
    { key: "stationservices", label: "Carburants" },
  ];

  mounted(): void {
    vehicules.vehicules();
    vehicules.stationsServices();
  }

  private date(date: string, format = "DD/MM/YYYY"): string {
    return dayjs(date).format(format);
  }

  get vehicules(): Vehicule[] | null {
    return vehicules.getVehicules;
  }

  get stations(): any | null {
    return vehicules.getStationsServices;
  }
}
